export default __webpack_public_path__ + "ff4e0f8992104dfe0d884ed8f7b7aa2e.jpg";